import { VENEER_APPROVAL_FAILED, VENEER_APPROVAL_REQUEST, VENEER_APPROVAL_SUCCESS } from "app/redux/Approval/VeneerApproval/constant";

const INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null
    }
};

export const veneerApprovalReducer = function (state = INIT_STATE, action) {
    switch (action?.type) {
        case VENEER_APPROVAL_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null
                }
            }
        case VENEER_APPROVAL_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null
                }
            }
        case VENEER_APPROVAL_FAILED:
            const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message
                }
            }
        default:
            return state;
    }
};